
import { Component, Prop, Watch } from "vue-property-decorator"
import BaseInput from "~/core/BaseInput"
import { _isEmpty, _isEqual, _isUndefined } from "~/utils/lodash"
import {
  buildURLTrackingOption,
  parseURLTrackingOption,
  URLTrackingOptionValue,
} from "~/utils/URLTrackingOptionHelper"

@Component
export default class URLTrackingOptionField extends BaseInput {
  @Prop({ type: Object }) personalize?: {
    text?: string
    pos?: number
    databases?: string[]
    disabled?: boolean
  }

  urlValue = ""
  persValue: URLTrackingOptionValue = "default"
  shortValue: URLTrackingOptionValue = "default"

  optionItems = [
    { text: "Default", value: "default" },
    { text: "True", value: "true" },
    { text: "False", value: "false" },
  ]

  mounted() {
    this.syncFromValue(this.innerValue)
  }

  get isPersonalize(): boolean {
    return !(_isUndefined(this.personalize) || _isEmpty(this.personalize))
  }

  get isDisabled(): boolean {
    return this.disabled || !this.$auth.canEditField(this.permissionKey)
  }

  optionText(value: URLTrackingOptionValue) {
    const option = this.optionItems.find((item) => item.value === value)
    return option?.text || "Default"
  }

  onURLInput(value: string) {
    this.urlValue = value || ""
    this.updateRawValue()
  }

  onPersInput(value: URLTrackingOptionValue) {
    this.persValue = value
    this.updateRawValue()
  }

  onShortInput(value: URLTrackingOptionValue) {
    this.shortValue = value
    this.updateRawValue()
  }

  onEmitEvent(ev) {
    this.$emit("event", ev)
  }

  updateRawValue() {
    this.innerValue = buildURLTrackingOption(this.urlValue, {
      pers: this.persValue,
      short: this.shortValue,
    })
  }

  syncFromValue(value: string) {
    const parsed = parseURLTrackingOption(value)
    this.urlValue = parsed.url
    this.persValue = parsed.options.pers
    this.shortValue = parsed.options.short
  }

  @Watch("value", { deep: true })
  onValueChange(value: any, oldValue: any) {
    if (!_isEqual(value, oldValue)) {
      this.innerValue = value
      this.syncFromValue(value)
    }
  }
}
